var map = {
	"./StaticPage": "GWPx",
	"./StaticPage.tsx": "GWPx",
	"./bannerModule/bannerContent/bannerContent": "BZyL",
	"./bannerModule/bannerContent/bannerContent.tsx": "BZyL",
	"./bannerModule/bannerModule": "U/q2",
	"./bannerModule/bannerModule.tsx": "U/q2",
	"./bannerModuleCarousel/bannerModuleCarousel": "yMXq",
	"./bannerModuleCarousel/bannerModuleCarousel.tsx": "yMXq",
	"./bannerModuleGroup/bannerModuleGroup": "10cs",
	"./bannerModuleGroup/bannerModuleGroup.tsx": "10cs",
	"./bannerModuleStrip/bannerModuleStrip": "bN/k",
	"./bannerModuleStrip/bannerModuleStrip.stories": "FYeq",
	"./bannerModuleStrip/bannerModuleStrip.stories.tsx": "FYeq",
	"./bannerModuleStrip/bannerModuleStrip.tsx": "bN/k",
	"./bannerModuleStripTimer/bannerModuleStripTimer": "dy2L",
	"./bannerModuleStripTimer/bannerModuleStripTimer.stories": "9Q0U",
	"./bannerModuleStripTimer/bannerModuleStripTimer.stories.tsx": "9Q0U",
	"./bannerModuleStripTimer/bannerModuleStripTimer.tsx": "dy2L",
	"./bannerSlider/bannerSlider": "P7hK",
	"./bannerSlider/bannerSlider.tsx": "P7hK",
	"./bannerTimer/CountdownTimer": "h2A2",
	"./bannerTimer/CountdownTimer.tsx": "h2A2",
	"./bannerTimer/bannerTimer": "UxAP",
	"./bannerTimer/bannerTimer.stories": "IjyT",
	"./bannerTimer/bannerTimer.stories.tsx": "IjyT",
	"./bannerTimer/bannerTimer.tsx": "UxAP",
	"./componentsRender/componentArea": "o6FR",
	"./componentsRender/componentArea.tsx": "o6FR",
	"./componentsRender/componentColumn": "yHwe",
	"./componentsRender/componentColumn.tsx": "yHwe",
	"./componentsRender/componentRow": "bO9O",
	"./componentsRender/componentRow.tsx": "bO9O",
	"./componentsRender/componentsRender": "SNqk",
	"./componentsRender/componentsRender.tsx": "SNqk",
	"./dynamicProducts/dynamicProducts": "ZbJY",
	"./dynamicProducts/dynamicProducts.tsx": "ZbJY",
	"./dynamicProducts/productList": "LUlN",
	"./dynamicProducts/productList.tsx": "LUlN",
	"./dynamicProducts/recommendedProducts": "oSik",
	"./dynamicProducts/recommendedProducts.tsx": "oSik",
	"./extraCartCms": "mWcX",
	"./extraCartCms.tsx": "mWcX",
	"./heroProductList/heroProductList": "DTmo",
	"./heroProductList/heroProductList.tsx": "DTmo",
	"./htmlTemplate/htmlTemplate": "pO7x",
	"./htmlTemplate/htmlTemplate.stories": "Wv68",
	"./htmlTemplate/htmlTemplate.stories.tsx": "Wv68",
	"./htmlTemplate/htmlTemplate.tsx": "pO7x",
	"./moduleHeader/moduleHeader": "LHGb",
	"./moduleHeader/moduleHeader.tsx": "LHGb",
	"./productHighlight/productHighlight": "TaU6",
	"./productHighlight/productHighlight.tsx": "TaU6",
	"./staticComponent": "1MPX",
	"./staticComponent.tsx": "1MPX",
	"./staticDataPleaseNeverDelete": "JnpR",
	"./staticDataPleaseNeverDelete.json": "JnpR",
	"./staticDataPleaseNeverDeleteOriginal": "iNE6",
	"./staticDataPleaseNeverDeleteOriginal.json": "iNE6",
	"./staticNavigation/staticNavigation": "wAPA",
	"./staticNavigation/staticNavigation.tsx": "wAPA",
	"./textLinks/textLinks": "QFk+",
	"./textLinks/textLinks.tsx": "QFk+",
	"./videoModule/videoModule": "6YvE",
	"./videoModule/videoModule.stories": "BjNT",
	"./videoModule/videoModule.stories.tsx": "BjNT",
	"./videoModule/videoModule.tsx": "6YvE"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = "lS6k";
module.exports = webpackContext;